export enum WayOfPayment {
  Undefined = 0,
  BankAccount = 1,
  PlusGiro = 2,
  BankGiro = 3,
  Other = 4,
}
